package com.eladfinish.bible.contest

import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.`internal`.SupportedLocale
import dev.icerock.moko.resources.`internal`.SupportedLocales
import dev.icerock.moko.resources.provider.RemoteJsStringLoader
import kotlin.String
import kotlin.collections.List

private val fallbackFileUrl: String =
    js("require(\"./localization/comeladfinishbiblecontest_stringsJson.json\")") as String

private val supportedLocales: SupportedLocales = SupportedLocales(listOf(
    SupportedLocale("de",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_de.json\")") as String),
    SupportedLocale("en",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_en.json\")") as String),
    SupportedLocale("es",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_es.json\")") as String),
    SupportedLocale("fr",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_fr.json\")") as String),
    SupportedLocale("ru",
        js("require(\"./localization/comeladfinishbiblecontest_stringsJson_ru.json\")") as String),
    ))

private val stringsLoader: RemoteJsStringLoader = RemoteJsStringLoader.Impl(supportedLocales =
    supportedLocales, fallbackFileUri = fallbackFileUrl)

internal object CommonMainStrings2 {
  internal val each_verse_in_new_line: StringResource by lazy { init_each_verse_in_new_line() }

  internal val elad: StringResource by lazy { init_elad() }

  internal val empty_mikud: StringResource by lazy { init_empty_mikud() }

  internal val enter_answer: StringResource by lazy { init_enter_answer() }

  internal val enter_deceased_name: StringResource by lazy { init_enter_deceased_name() }

  internal val enter_email: StringResource by lazy { init_enter_email() }

  internal val enter_first_name: StringResource by lazy { init_enter_first_name() }

  internal val enter_last_name: StringResource by lazy { init_enter_last_name() }

  internal val enter_question: StringResource by lazy { init_enter_question() }

  internal val enter_valid_email: StringResource by lazy { init_enter_valid_email() }

  internal val error: StringResource by lazy { init_error() }

  internal val error_try_again_later: StringResource by lazy { init_error_try_again_later() }

  internal val exit: StringResource by lazy { init_exit() }

  internal val export_search_results: StringResource by lazy { init_export_search_results() }

  internal val export_to_file: StringResource by lazy { init_export_to_file() }

  internal val exporting_to_file: StringResource by lazy { init_exporting_to_file() }

  internal val expression_to_be_searched_format: StringResource by lazy {
      init_expression_to_be_searched_format() }

  internal val expression_to_search: StringResource by lazy { init_expression_to_search() }

  internal val fifty_fifty: StringResource by lazy { init_fifty_fifty() }

  internal val file_not_exists: StringResource by lazy { init_file_not_exists() }

  internal val file_not_saved: StringResource by lazy { init_file_not_saved() }

  internal val file_saved_successfully: StringResource by lazy { init_file_saved_successfully() }

  internal val file_was_not_saved: StringResource by lazy { init_file_was_not_saved() }

  internal val fine: StringResource by lazy { init_fine() }

  internal val first_last_letters_in_name: StringResource by lazy {
      init_first_last_letters_in_name() }

  internal val first_select_questions_topic: StringResource by lazy {
      init_first_select_questions_topic() }

  internal val font_format: StringResource by lazy { init_font_format() }

  internal val font_preview: StringResource by lazy { init_font_preview() }

  internal val font_size_change: StringResource by lazy { init_font_size_change() }

  internal val free_trial_3_days: StringResource by lazy { init_free_trial_3_days() }

  internal val full_chapter: StringResource by lazy { init_full_chapter() }

  internal val full_pasuk: StringResource by lazy { init_full_pasuk() }

  internal val full_version: StringResource by lazy { init_full_version() }

  internal val future_settings: StringResource by lazy { init_future_settings() }

  internal val gender_female: StringResource by lazy { init_gender_female() }

  internal val gender_male: StringResource by lazy { init_gender_male() }

  internal val gender_men: StringResource by lazy { init_gender_men() }

  internal val gender_preference_error: StringResource by lazy { init_gender_preference_error() }

  internal val gender_preference_sentence: StringResource by lazy {
      init_gender_preference_sentence() }

  internal val gender_preference_title: StringResource by lazy { init_gender_preference_title() }

  internal val gender_women: StringResource by lazy { init_gender_women() }

  internal val generic_error_message: StringResource by lazy { init_generic_error_message() }

  internal val genesis: StringResource by lazy { init_genesis() }

  internal val goalenu: StringResource by lazy { init_goalenu() }

  internal val good_job_all_items_sorted: StringResource by lazy { init_good_job_all_items_sorted()
      }

  internal val good_job_all_pairs_matched: StringResource by lazy {
      init_good_job_all_pairs_matched() }

  internal val haftarah: StringResource by lazy { init_haftarah() }

  internal val haftarat: StringResource by lazy { init_haftarat() }

  internal val half_pasuk: StringResource by lazy { init_half_pasuk() }

  internal val half_value: StringResource by lazy { init_half_value() }

  internal fun values(): List<StringResource> = listOf(each_verse_in_new_line, elad, empty_mikud,
      enter_answer, enter_deceased_name, enter_email, enter_first_name, enter_last_name,
      enter_question, enter_valid_email, error, error_try_again_later, exit, export_search_results,
      export_to_file, exporting_to_file, expression_to_be_searched_format, expression_to_search,
      fifty_fifty, file_not_exists, file_not_saved, file_saved_successfully, file_was_not_saved,
      fine, first_last_letters_in_name, first_select_questions_topic, font_format, font_preview,
      font_size_change, free_trial_3_days, full_chapter, full_pasuk, full_version, future_settings,
      gender_female, gender_male, gender_men, gender_preference_error, gender_preference_sentence,
      gender_preference_title, gender_women, generic_error_message, genesis, goalenu,
      good_job_all_items_sorted, good_job_all_pairs_matched, haftarah, haftarat, half_pasuk,
      half_value)
}

private fun init_each_verse_in_new_line(): StringResource = StringResource(key =
    "each_verse_in_new_line", loader = stringsLoader)

private fun init_elad(): StringResource = StringResource(key = "elad", loader = stringsLoader)

private fun init_empty_mikud(): StringResource = StringResource(key = "empty_mikud", loader =
    stringsLoader)

private fun init_enter_answer(): StringResource = StringResource(key = "enter_answer", loader =
    stringsLoader)

private fun init_enter_deceased_name(): StringResource = StringResource(key = "enter_deceased_name",
    loader = stringsLoader)

private fun init_enter_email(): StringResource = StringResource(key = "enter_email", loader =
    stringsLoader)

private fun init_enter_first_name(): StringResource = StringResource(key = "enter_first_name",
    loader = stringsLoader)

private fun init_enter_last_name(): StringResource = StringResource(key = "enter_last_name", loader
    = stringsLoader)

private fun init_enter_question(): StringResource = StringResource(key = "enter_question", loader =
    stringsLoader)

private fun init_enter_valid_email(): StringResource = StringResource(key = "enter_valid_email",
    loader = stringsLoader)

private fun init_error(): StringResource = StringResource(key = "error", loader = stringsLoader)

private fun init_error_try_again_later(): StringResource = StringResource(key =
    "error_try_again_later", loader = stringsLoader)

private fun init_exit(): StringResource = StringResource(key = "exit", loader = stringsLoader)

private fun init_export_search_results(): StringResource = StringResource(key =
    "export_search_results", loader = stringsLoader)

private fun init_export_to_file(): StringResource = StringResource(key = "export_to_file", loader =
    stringsLoader)

private fun init_exporting_to_file(): StringResource = StringResource(key = "exporting_to_file",
    loader = stringsLoader)

private fun init_expression_to_be_searched_format(): StringResource = StringResource(key =
    "expression_to_be_searched_format", loader = stringsLoader)

private fun init_expression_to_search(): StringResource = StringResource(key =
    "expression_to_search", loader = stringsLoader)

private fun init_fifty_fifty(): StringResource = StringResource(key = "fifty_fifty", loader =
    stringsLoader)

private fun init_file_not_exists(): StringResource = StringResource(key = "file_not_exists", loader
    = stringsLoader)

private fun init_file_not_saved(): StringResource = StringResource(key = "file_not_saved", loader =
    stringsLoader)

private fun init_file_saved_successfully(): StringResource = StringResource(key =
    "file_saved_successfully", loader = stringsLoader)

private fun init_file_was_not_saved(): StringResource = StringResource(key = "file_was_not_saved",
    loader = stringsLoader)

private fun init_fine(): StringResource = StringResource(key = "fine", loader = stringsLoader)

private fun init_first_last_letters_in_name(): StringResource = StringResource(key =
    "first_last_letters_in_name", loader = stringsLoader)

private fun init_first_select_questions_topic(): StringResource = StringResource(key =
    "first_select_questions_topic", loader = stringsLoader)

private fun init_font_format(): StringResource = StringResource(key = "font_format", loader =
    stringsLoader)

private fun init_font_preview(): StringResource = StringResource(key = "font_preview", loader =
    stringsLoader)

private fun init_font_size_change(): StringResource = StringResource(key = "font_size_change",
    loader = stringsLoader)

private fun init_free_trial_3_days(): StringResource = StringResource(key = "free_trial_3_days",
    loader = stringsLoader)

private fun init_full_chapter(): StringResource = StringResource(key = "full_chapter", loader =
    stringsLoader)

private fun init_full_pasuk(): StringResource = StringResource(key = "full_pasuk", loader =
    stringsLoader)

private fun init_full_version(): StringResource = StringResource(key = "full_version", loader =
    stringsLoader)

private fun init_future_settings(): StringResource = StringResource(key = "future_settings", loader
    = stringsLoader)

private fun init_gender_female(): StringResource = StringResource(key = "gender_female", loader =
    stringsLoader)

private fun init_gender_male(): StringResource = StringResource(key = "gender_male", loader =
    stringsLoader)

private fun init_gender_men(): StringResource = StringResource(key = "gender_men", loader =
    stringsLoader)

private fun init_gender_preference_error(): StringResource = StringResource(key =
    "gender_preference_error", loader = stringsLoader)

private fun init_gender_preference_sentence(): StringResource = StringResource(key =
    "gender_preference_sentence", loader = stringsLoader)

private fun init_gender_preference_title(): StringResource = StringResource(key =
    "gender_preference_title", loader = stringsLoader)

private fun init_gender_women(): StringResource = StringResource(key = "gender_women", loader =
    stringsLoader)

private fun init_generic_error_message(): StringResource = StringResource(key =
    "generic_error_message", loader = stringsLoader)

private fun init_genesis(): StringResource = StringResource(key = "genesis", loader = stringsLoader)

private fun init_goalenu(): StringResource = StringResource(key = "goalenu", loader = stringsLoader)

private fun init_good_job_all_items_sorted(): StringResource = StringResource(key =
    "good_job_all_items_sorted", loader = stringsLoader)

private fun init_good_job_all_pairs_matched(): StringResource = StringResource(key =
    "good_job_all_pairs_matched", loader = stringsLoader)

private fun init_haftarah(): StringResource = StringResource(key = "haftarah", loader =
    stringsLoader)

private fun init_haftarat(): StringResource = StringResource(key = "haftarat", loader =
    stringsLoader)

private fun init_half_pasuk(): StringResource = StringResource(key = "half_pasuk", loader =
    stringsLoader)

private fun init_half_value(): StringResource = StringResource(key = "half_value", loader =
    stringsLoader)

public actual val SharedRes.strings.each_verse_in_new_line: StringResource
  get() = CommonMainStrings2.each_verse_in_new_line

public actual val SharedRes.strings.elad: StringResource
  get() = CommonMainStrings2.elad

public actual val SharedRes.strings.empty_mikud: StringResource
  get() = CommonMainStrings2.empty_mikud

public actual val SharedRes.strings.enter_answer: StringResource
  get() = CommonMainStrings2.enter_answer

public actual val SharedRes.strings.enter_deceased_name: StringResource
  get() = CommonMainStrings2.enter_deceased_name

public actual val SharedRes.strings.enter_email: StringResource
  get() = CommonMainStrings2.enter_email

public actual val SharedRes.strings.enter_first_name: StringResource
  get() = CommonMainStrings2.enter_first_name

public actual val SharedRes.strings.enter_last_name: StringResource
  get() = CommonMainStrings2.enter_last_name

public actual val SharedRes.strings.enter_question: StringResource
  get() = CommonMainStrings2.enter_question

public actual val SharedRes.strings.enter_valid_email: StringResource
  get() = CommonMainStrings2.enter_valid_email

public actual val SharedRes.strings.error: StringResource
  get() = CommonMainStrings2.error

public actual val SharedRes.strings.error_try_again_later: StringResource
  get() = CommonMainStrings2.error_try_again_later

public actual val SharedRes.strings.exit: StringResource
  get() = CommonMainStrings2.exit

public actual val SharedRes.strings.export_search_results: StringResource
  get() = CommonMainStrings2.export_search_results

public actual val SharedRes.strings.export_to_file: StringResource
  get() = CommonMainStrings2.export_to_file

public actual val SharedRes.strings.exporting_to_file: StringResource
  get() = CommonMainStrings2.exporting_to_file

public actual val SharedRes.strings.expression_to_be_searched_format: StringResource
  get() = CommonMainStrings2.expression_to_be_searched_format

public actual val SharedRes.strings.expression_to_search: StringResource
  get() = CommonMainStrings2.expression_to_search

public actual val SharedRes.strings.fifty_fifty: StringResource
  get() = CommonMainStrings2.fifty_fifty

public actual val SharedRes.strings.file_not_exists: StringResource
  get() = CommonMainStrings2.file_not_exists

public actual val SharedRes.strings.file_not_saved: StringResource
  get() = CommonMainStrings2.file_not_saved

public actual val SharedRes.strings.file_saved_successfully: StringResource
  get() = CommonMainStrings2.file_saved_successfully

public actual val SharedRes.strings.file_was_not_saved: StringResource
  get() = CommonMainStrings2.file_was_not_saved

public actual val SharedRes.strings.fine: StringResource
  get() = CommonMainStrings2.fine

public actual val SharedRes.strings.first_last_letters_in_name: StringResource
  get() = CommonMainStrings2.first_last_letters_in_name

public actual val SharedRes.strings.first_select_questions_topic: StringResource
  get() = CommonMainStrings2.first_select_questions_topic

public actual val SharedRes.strings.font_format: StringResource
  get() = CommonMainStrings2.font_format

public actual val SharedRes.strings.font_preview: StringResource
  get() = CommonMainStrings2.font_preview

public actual val SharedRes.strings.font_size_change: StringResource
  get() = CommonMainStrings2.font_size_change

public actual val SharedRes.strings.free_trial_3_days: StringResource
  get() = CommonMainStrings2.free_trial_3_days

public actual val SharedRes.strings.full_chapter: StringResource
  get() = CommonMainStrings2.full_chapter

public actual val SharedRes.strings.full_pasuk: StringResource
  get() = CommonMainStrings2.full_pasuk

public actual val SharedRes.strings.full_version: StringResource
  get() = CommonMainStrings2.full_version

public actual val SharedRes.strings.future_settings: StringResource
  get() = CommonMainStrings2.future_settings

public actual val SharedRes.strings.gender_female: StringResource
  get() = CommonMainStrings2.gender_female

public actual val SharedRes.strings.gender_male: StringResource
  get() = CommonMainStrings2.gender_male

public actual val SharedRes.strings.gender_men: StringResource
  get() = CommonMainStrings2.gender_men

public actual val SharedRes.strings.gender_preference_error: StringResource
  get() = CommonMainStrings2.gender_preference_error

public actual val SharedRes.strings.gender_preference_sentence: StringResource
  get() = CommonMainStrings2.gender_preference_sentence

public actual val SharedRes.strings.gender_preference_title: StringResource
  get() = CommonMainStrings2.gender_preference_title

public actual val SharedRes.strings.gender_women: StringResource
  get() = CommonMainStrings2.gender_women

public actual val SharedRes.strings.generic_error_message: StringResource
  get() = CommonMainStrings2.generic_error_message

public actual val SharedRes.strings.genesis: StringResource
  get() = CommonMainStrings2.genesis

public actual val SharedRes.strings.goalenu: StringResource
  get() = CommonMainStrings2.goalenu

public actual val SharedRes.strings.good_job_all_items_sorted: StringResource
  get() = CommonMainStrings2.good_job_all_items_sorted

public actual val SharedRes.strings.good_job_all_pairs_matched: StringResource
  get() = CommonMainStrings2.good_job_all_pairs_matched

public actual val SharedRes.strings.haftarah: StringResource
  get() = CommonMainStrings2.haftarah

public actual val SharedRes.strings.haftarat: StringResource
  get() = CommonMainStrings2.haftarat

public actual val SharedRes.strings.half_pasuk: StringResource
  get() = CommonMainStrings2.half_pasuk

public actual val SharedRes.strings.half_value: StringResource
  get() = CommonMainStrings2.half_value
